import React from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';



const About = ({ data }) => {
  const { title, avater } = data;

  return (
    <section className="st-about-wrap" id='about'>
      <div className="st-shape-bg">
        <img src="/shape/about-bg-shape.svg" alt="/shape/about-bg-shape.svg" />
      </div>
      <div className="st-height-b120 st-height-lg-b50" />
      <SectionHeading title="Chi sono"
              subTitle="Benvenuta! Sono la Dott.ssa Rosa Coppola, Ginecologa e Medico Estetico, con <br>una consolidata esperienza in strutture sanitarie di eccellenza." />
      <div className="container">
        <div className="row" style={{marginTop:'35px'}}>
          <div className="col-lg-7">
            <div className="st-vertical-middle">
              <div className="st-vertical-middle-in">
                <div className="st-text-block st-style1">
                  <h2 className="st-text-block-title">{title}</h2>
                  <div className="st-height-b20 st-height-lg-b20" />
                  <div className="st-text-block-text">
                                      <p>Mi sono laureata in Medicina e Chirurgia presso l’<strong>Università di Siena</strong> e specializzata in Ginecologia e Ostetricia presso l’<strong>Università di Perugia</strong>. Ho maturato esperienza presso diverse strutture sanitarie, tra cui:</p>

                                      <ul>
                                          <li><strong>Clinica Santa Patrizia</strong> – Napoli</li>
                                          <li><strong>Ospedale Fatebenefratelli</strong> – Benevento</li>
                                          <li><strong>Clinica del Sole</strong> – Salerno</li>
                                      </ul>

                                      <p>Ho ricoperto il ruolo di <strong>Dirigente Medico di 1° livello</strong> presso:</p>

                                      <ul>
                                          <li><strong>UOC di Ostetricia e Ginecologia del P.O. di Lagonegro</strong></li>
                                          <li><strong>U.O. dell’Ospedale L. Curto di Polla</strong></li>
                                      </ul>

                                      <p>Attualmente lavoro come <strong>Ginecologa</strong> presso il Distretto Sanitario 72 (Sala Consilina, Sant’Arsenio, Teggiano, Padula) ed esercito la libera professione in diversi studi. Sono inoltre iscritta all’Albo dei Consulenti Medici del Tribunale di Salerno.</p>
                  </div>
                  <div className="st-height-b25 st-height-lg-b25" />
                  <div className="st-text-block-avatar">
                    <div className="st-avatar-img">
                      <img src={`${avater.img}`} alt={`${avater.img}`} />
                    </div>
                    <div className="st-avatar-info">
                      <h4 className="st-avatar-name">{avater.name}</h4>
                      <div className="st-avatar-designation">{avater.designation}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="st-height-b0 st-height-lg-b30" />
          </div>
          {/* .col */}
          <div className="col-lg-5 wow fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.2s" >
            <img src="images/rosacoppola.png" alt="Dott.ssa Rosa Coppola" className="ImgAbout"></img>
          </div>
        </div>
        <div className="row" style={{margin:'90px 0 90px 0'}}>
            <div className="st-vertical-middle">
              <div className="st-vertical-middle-in">
                <div className="st-text-block st-style1">
                  <h2 className="st-text-block-title">Il mio impegno per le donne </h2>
                  <div className="st-height-b20 st-height-lg-b20" />
                  <div className="st-text-block-text">
                    <p>Da sempre il mio obiettivo è <strong>accompagnare le donne con cura e rispetto</strong> nel loro percorso di vita:</p>

                    <ul>
                      <li><strong>Dalla pubertà alla menopausa</strong>, offrendo supporto ginecologico in ogni fase</li>
                      <li><strong>Durante la gravidanza</strong>, seguendole nel meraviglioso viaggio che le porta a diventare madri</li>
                      <li><strong>Nel benessere intimo</strong>, con trattamenti mirati per ritrovare sicurezza e comfort</li>
                    </ul>

                    <p>Mi sono specializzata in <strong>trattamenti ambulatoriali, sicuri e non invasivi</strong> per il <strong>ringiovanimento vulvo-vaginale</strong>, aiutando le donne a superare disturbi spesso trascurati come:</p>

                    <ul>
                      <li>Incontinenza urinaria da stress</li>
                      <li>Secchezza, atrofia e lassità vaginale</li>
                      <li>Infezioni vaginali ricorrenti</li>
                    </ul>
                  </div>
                  <h2 className="st-text-block-title"  style={{marginTop:'50px'}}>Medicina estetica e trattamenti non invasivi</h2>
                  <div className="st-height-b20 st-height-lg-b20" />
                  <div className="st-text-block-text">
                    <p>Oltre alla ginecologia, mi occupo di <strong>Medicina Estetica</strong>, per aiutare ogni donna a sentirsi a proprio agio con il suo aspetto. Offro trattamenti efficaci e non invasivi per il <strong>ringiovanimento del viso e della pelle</strong>.</p>

                    <p>Il mio motto è da sempre “<strong>Con le Donne, Per le Donne</strong>”, perché credo profondamente che ogni donna meriti di sentirsi ascoltata, supportata e valorizzata.</p>

                    <p>Affidarsi a me è un atto di fiducia prezioso, che accolgo con <strong>rispetto, empatia e professionalità</strong>. Nel mio lavoro, non vedo solo pazienti, ma <strong>donne con esigenze, emozioni e sogni</strong>, ed è per questo che il mio impegno va oltre la cura: mi dedico ad ascoltare, comprendere e offrire soluzioni efficaci per il loro benessere.</p>

                  </div>
                </div>
              </div>
            </div>
        </div>
        </div>
    </section>
  )
}

export default About
